<template>
  <ipo3-page>
    <template slot="title">彈窗管理</template>
    <template slot="tools">
      <el-select v-model="form.language" @change="onChangeLanguage" style="margin-right: 14px;">
        <el-option v-for="item in languages" :key="item.name" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">{{$t('btns.add')}}</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleCurrentChange"
          :header-cell-style="getRowClass"
        >
          
          <template v-for="item in items">
           
            <el-table-column
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row.id)"
                  size="mini"
                  type="success"
                >編輯</el-button>
                <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "popups",
  data() {
    return {
      activeName: "1",
      languages: [{id: 'tw', name: '中文繁體'}, {id: 'cn', name: '中文简体'}, {id: 'en', name: '英文'}],
      form:{
        language: 'tw'
      },
      tableData: [],
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" },
        { name: "是否顯示", id: "status_text" },
        { name: "開始日期", id: "date_from" },
        { name: "結束日期", id: "date_to" },
        { name: "建立時間", id: "create_time" }
      ],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },

  created() {
    this.getData();
  },

  watch: {
    $route: {
      async handler(newVal) {
        let params = this.$route.query;
        if (params.language != undefined && params.language != null && params.language != '')
          this.form.language = params.language;
        this.currentPage = params.page||1;
        this.paginate = params.size||10;
        this.getData(this.currentPage, this.paginate, params);
      },
      immediate: true,
    }
  },

  methods: {
    getData(page=1, size=10, params={}) {
      var self = this;
      this.$http.get("/admin/popup", {page:page,size:size,...params}).then(res => {
        let {data,total} = res.data;
        self.pagecount = total;
        self.tableData = res.data.data;
      });
    },

    onCreate() {
      this.$router.push({ path: "/popup/edit", query: {language:this.language}});
    },

    onHandle(index, id) {
      this.$router.push({ path: `/popup/edit/${id}` });
    },

    handleSizeChange(size)
    {
      let params = Object.assign({},this.form);
      this.paginate = size;
      params.page = 1;
      params.size = this.paginate;
      this.$router.push({path:'/popup',query:params})
    },

    handleCurrentChange(val)
    {
      let params = Object.assign({},this.form);
      params.page = val;
      params.size = this.paginate;
      this.$router.push({path:'/popup',query:params});
    },

    onDelete(index,value)
    {
      var self = this;
      this.$http.post('/admin/popup/delete',{id:value.id}).then(res=>{
          if(res.code==200)
          {
            let params = Object.assign({},this.form);
            self.getData(this.currentPage, this.paginate, params);
            self.$message.success("删除成功");
          }else
          {
            self.$message.error(res.msg);
          }
      });
    },

    onChangeLanguage(value) {
      let params = Object.assign({},this.form);
      this.currentPage = 1;
      this.getData(this.currentPage, this.paginate, params);
    },
  }
};
</script>